import type { FC } from "react"

import { FilesTable } from "@/components/Tables/Aeros/components/FilesTable"
import type { SignedUrl } from "@/graphql/codegen/graphql"
import { usePurchaseOrderFilesColumns } from "@/screens/Procurement/PurchaseOrder/components/PurchaseOrderFiles/tables/usePurchaseOrderFilesColumns"

interface PurchaseOrderFileTableProps {
  data: SignedUrl[]
  isLoading: boolean
  onRemove: (fileId: string) => Promise<void>
  isReadonly?: boolean
  error?: Error
}

export const PurchaseOrderFileTable: FC<PurchaseOrderFileTableProps> = ({
  data,
  isLoading,
  error,
  onRemove,
  isReadonly = false,
}) => {
  const columns = usePurchaseOrderFilesColumns({ onRemove, isReadonly })

  return (
    <FilesTable
      columns={columns}
      data={data}
      isLoading={isLoading}
      error={error}
      noDataMessage='No purchase order documents found'
    />
  )
}
